import React, {useEffect} from 'react';
import {BrowserRouter, Route, Navigate, Routes} from "react-router-dom";
import Login from "./pages/Login.js";
import Account from "./helpers/Account.js";
import Staff from "./pages/Staff.js";
import Profile from "./pages/Profile.js";
import Tasks from "./pages/Tasks.js";
import StaffList from "./pages/StaffList.js";
import Employee from "./pages/Employee.js";
import Organizations from "./pages/Organizations.js";
import OrganizationSingle from "./pages/OrganizationSingle.js";
import Users from "./pages/Users.js";
import UserSingle from "./pages/UserSingle.js";
import {connectSocket, disconnectSocket} from "./helpers/socket.js";
import {connectNotificationSocket, disconnectNotificationSocket} from "./helpers/notificationSocket.js";
import {connectDayoffSocket, disconnectDayoffSocket} from "./helpers/dayOffSocket.js";
import {useDispatch, useSelector} from "react-redux";
import TaskSingle from "./pages/TaskSingle.js";
import Archive from "./pages/Archive.js";
import RepeatedTask from "./pages/RepeatedTask.js";
import RepeatedTaskPage from "./pages/RepeatedTaskPage.js";
import Notifications from "./pages/Notifications.js";
import NotificationPage from "./pages/NotificationPage.js";
import Reports from "./pages/Reports.js";
import Files from "./pages/Files.js";
import Note from "./pages/Note.js";
import DayOff from "./pages/DayOff.js";
import StaffTeams from "./pages/StaffTeams.js";
import Surveys from "./pages/Surveys.js";
import SurveySingle from "./pages/SurveySingle.js";
import {connectSurveySocket, disconnectSurveySocket} from "./helpers/surveySocket.js";
import {connectMessageSocket, disconnectMessageSocket} from "./helpers/messageSocket.js";
import Calendar from "./pages/Calendar.js";
import AgentTask from './pages/AgentTask.js';
import Wallet from './pages/Wallet.js';
import AgentSingle from './pages/AgentSingle.js';
import Accept from './pages/Accept.js';
import AdminAgent from './pages/AdminAgent.js';
import './assets/css/theme.css';

function App() {
    const dispatch = useDispatch();
    const token = useSelector((state) => state.manager.token) || localStorage.getItem('token');
    const accountantArray = useSelector((state) => state.manager.accountantArray) || []
    
    // Apply theme based on REACT_APP_SERVER
    useEffect(() => {
        const server = process.env.REACT_APP_SERVER;
        if (server === 'PEK') {
            document.body.classList.add('pek-theme');
        } else {
            document.body.classList.remove('pek-theme');
        }
    }, []);
    
    useEffect(() => {
        try{
            if (Notification.permission !== "granted") {
                Notification.requestPermission();
            }
            if (token) {
                connectSocket(token, dispatch,accountantArray); // ✅ Pass dispatch
                connectNotificationSocket(token, dispatch); // ✅ Pass dispatch
                connectMessageSocket(token, dispatch); // ✅ Pass dispatch
                connectDayoffSocket(token, dispatch,accountantArray); // ✅ Pass dispatch
                connectSurveySocket(token, dispatch,accountantArray); // ✅ Pass dispatch
            } else {
                console.error("⚠️ No token found!");
            }
            return () => {
                disconnectSocket();
                disconnectNotificationSocket();
                disconnectDayoffSocket();
                disconnectSurveySocket();
                disconnectMessageSocket();
            };
        }catch (e) {
            console.log(e.toString())
        }
    }, [token,accountantArray]);
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<Navigate to={Account.getToken()?localStorage.getItem('profession') === "manager" ?"/main_employee/staff":localStorage.getItem('profession')==="accountant" ?"/main_employee/tasks":'/main_employee/agent-task':"/employee"} replace/>}/>
                <Route path="/employee" element={<Login/>}/>
                <Route path="/accept/:id" element={<Accept/>}/>
                <Route path="/main_employee/tasks" element={<Tasks/>}/>
                <Route path="/main_employee/staff" element={<StaffList/>}/>
                <Route path="/main_employee/agent-task" element={<AgentTask/>}/>
                <Route path="/main_employee/agent-task/:id" element={<AgentSingle/>}/>
                <Route path="/main_employee/wallet" element={<Wallet/>}/>
                <Route path="/main_employee/team" element={<StaffTeams/>}/>
                <Route path="/main_employee/surveys" element={<Surveys/>}/>
                <Route path="/main_employee/calendar" element={<Calendar/>}/>
                <Route path="/main_employee/surveys/:id" element={<SurveySingle/>}/>
                <Route path="/main_employee/staff/:type" element={<Staff/>}/>
                <Route path="/main_employee/staff/:type/:id" element={<Employee/>}/>
                <Route path="/main_employee/mypage" element={<Profile/>}/>
                <Route path="/main_employee/tasks/:id" element={<TaskSingle/>}/>
                <Route path="/main_employee/organization" element={<Organizations/>}/>
                <Route path="/main_employee/organization/:id" element={<OrganizationSingle/>}/>
                <Route path="/main_employee/users" element={<Users />}/>
                <Route path="/main_employee/users/:id" element={<UserSingle />}/>
                <Route path="/main_employee/archive" element={<Archive />}/>
                <Route path="/main_employee/archive/:id" element={<TaskSingle/>}/>
                <Route path="/main_employee/repeated_task" element={<RepeatedTask />}/>
                <Route path="/main_employee/repeated_task/:id" element={<RepeatedTaskPage/>}/>
                <Route path="/main_employee/notification" element={<Notifications/>}/>
                <Route path="/main_employee/notification/:id" element={<NotificationPage/>}/>
                <Route path="/main_employee/reports" element={<Reports />}/>
                <Route path="/main_employee/organization_file" element={<Files />}/>
                <Route path="/main_employee/day_off" element={<DayOff />}/>
                <Route path="/main_employee/admin-agent" element={<AdminAgent />}/>
                {/*<Route path="/main_employee/tasks/:name/:id" component={Tasks}/>*/}
                <Route path="/main_employee/note" element={<Note />}/>
                {/*<Redirect from="/*"*/}
                {/* {Account.getToken() ? <Route path="/*" element={<Navigate to="/main_employee/tasks" replace/>}/> :
                    <Route path="/*" element={<Login/>}/>} */}
            </Routes>

        </BrowserRouter>
    );
}

export default App;